<template>
  <div>
    <el-row>
      <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4'>
        <admin-menu @addUser='addUserEvent' @modifyUser='modifyUserEvent' @modifyRole='modifyRoleEvent'
          @addForeignUser='addForeignUserEvent' @addUniversity='addUniversityEvent'>
        </admin-menu>
      </el-col>
      <el-col :xs='24' :sm='24' :md='16' :lg='16' :xl='16'>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
        <foreign-user-search v-show="searchForeignVisible"></foreign-user-search>
        <statistics v-show="statsVisible"></statistics>
        <register-form v-show='addUser || modifyUser || modifyRole || addForeignUser' v-loading="loadingUser"
          :addUser='addUser' :addForeignUser='addForeignUser' :modifyUser='modifyUser' :modifyRole='modifyRole'
          :userData='modifyUserData' :roleId='roleId' :modifyFromUser='modifyFromUser' :academicAreas="academicAreas" @hideForm='hideForm'>
        </register-form>
        <manage-db :addUniversity='addUniversity' v-if='addUniversity' @hideForm='hideForm'></manage-db>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdminMenu from './roleSpecific/AdminMenu'
import ManageDb from './roleSpecific/ManageDb'
import RegisterForm from './common/RegisterForm'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import SearchUni from '@/components/common/SearchUni'
import ForeignUserSearch from '@/components/common/ForeignUserSearch'
import axios from 'axios'
import Statistics from '@/components/common/Statistics'

export default {
  name: 'Admin',
  components: {
    ManageDb,
    AdminMenu,
    RegisterForm,
    ApplicationSearch,
    SearchUni,
    ForeignUserSearch,
    Statistics
  },
  mounted: function () {
    this.$store.dispatch('LOAD_INTERNAL_USERS')
    this.$store.dispatch('LOAD_INTERNAL_ROLES')
    // this.$store.dispatch('LOAD_SPECIALTIES')
    this.$store.dispatch('LOAD_ACADEMIC_AREAS')
  },
  data () {
    return {
      modifyFromUser: false,
      addUser: false,
      addForeignUser: false,
      addUniversity: false,
      modifyUser: false,
      modifyRole: false,
      loadingUser: false,
      modifyUserData: {doatap_roles: []},
      roleId: 0
    }
  },
  methods: {
    hideForm () {
      this.addUser = false
      this.addForeignUser = false
      this.addUniversity = false
      this.modifyUser = false
      this.modifyRole = false
      this.modifyUserData = {}
    },
    addUserEvent () {
      this.addUser = !this.addUser
      this.addForeignUser = false
      this.addUniversity = false
      this.modifyUser = false
      this.modifyRole = false
      this.modifyUserData = {}
    },
    addUniversityEvent () {
      this.addUser = false
      this.addForeignUser = false
      this.addUniversity = !this.addUniversity
      this.modifyUser = false
      this.modifyRole = false
      this.modifyUserData = {}
    },
    addForeignUserEvent () {
      this.addUser = false
      this.addForeignUser = !this.addForeignUser
      this.addUniversity = false
      this.modifyUser = false
      this.modifyRole = false
      this.modifyUserData = {}
    },
    modifyUserEvent (id) {
      this.modifyUser = true
      this.addForeignUser = false
      this.addUniversity = false
      this.addUser = false
      this.modifyRole = false
      this.loadingUser = true
      axios.get(`${this.BASE_URL}/users/${id}`).then((response) => {
        this.modifyUserData = response.data.data
        this.loadingUser = false
      })
    },
    modifyRoleEvent (id) {
      this.modifyRole = true
      this.addUser = false
      this.addForeignUser = false
      this.addUniversity = false
      this.modifyUser = false
      this.roleId = id
    }
  },
  computed: {
    ...mapState([
      'searchVisible',
      'searchUniVisible',
      'statsVisible',
      'searchForeignVisible',
      'internalUsers',
      'BASE_URL',
      'academicAreas'
    ])
  }
}
</script>

<style lang="scss">
.list-group {
  min-height: 20px;
}

.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue